/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Dashboard_Error_ConvertingInputs */

const en_dashboard_error_converting = /** @type {(inputs: Dashboard_Error_ConvertingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error converting ${i?.title}`)
};

const es_dashboard_error_converting = /** @type {(inputs: Dashboard_Error_ConvertingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al convertir ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Error converting {title}" |
*
* @param {Dashboard_Error_ConvertingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_error_converting = /** @type {((inputs: Dashboard_Error_ConvertingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Error_ConvertingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_error_converting(inputs)
	return en_dashboard_error_converting(inputs)
});